export const iconFontAwesomeSportsFitnessBroomBall = (
	<i className="fa-solid fa-broom-ball"></i>
);
